export const supportedLocales: {[language: string]: string[]} = {es: ['es_es', 'es_mx', 'es_pe', 'es_co', 'es_ar', 'es_cl'],
    en: ['en_us', 'en_gb', 'en_ca', 'en_es', 'en_fr', 'en_ie', 'en_sg', 'en_au', 'en_nz', 'en_my', 'en_hk', 'en_th', 'en_ae', 'en_sa', 'en_qa', 'en_kw', 'en_za'],
    pt: ['pt_br'],
    zu: ['zu_za'],
    ar: ['ar_sa', 'ar_ae', 'ar_qa', 'ar_kw'],
    zh: ['zh_sg', 'zh_hk'],
    ms: ['ms_my'],
    uk: ['uk_ua'],
    sv: ['sv_se'],
    hr: ['hr_hr'],
    pl: ['pl_pl'],
    nl: ['nl_be'],
    it: ['it_it'],
    de: ['de_de'],
    fr: ['fr_fr', 'fr_ca']};
